import {
  RESET_STEP2_VALIDATION,
  SET_PREFIX_VALID,
  SET_NAME_VALID,
  SET_PURPOSE_VALID,
  SET_QUOTA_VALID,
  SET_TITLE_VALID,
  SET_TREE_DIGIT_CODE_VALID,
} from "../../actions/types";

// const valid ={isValid : true, message : "" }
const invalid = { isValid: false, message: "" };

const initialState = {
  PrefixValid: invalid,
  TitleValid: invalid,
  NameValid: invalid,
  PurposeValid: invalid,
  TreeDigitCodeValid: invalid,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PREFIX_VALID:
      return {
        ...state,
        PrefixValid: action.payload,
      };
    case SET_NAME_VALID:
      return {
        ...state,
        NameValid: action.payload,
      };

    case SET_TITLE_VALID:
      return {
        ...state,
        TitleValid: action.payload,
      };

    case SET_PURPOSE_VALID:
      return {
        ...state,
        PurposeValid: action.payload,
      };
    case SET_QUOTA_VALID:
      return {
        ...state,
        QuotaValid: action.payload,
      };
    case SET_TREE_DIGIT_CODE_VALID:
      return {
        ...state,
        TreeDigitCodeValid: action.payload,
      };
    case RESET_STEP2_VALIDATION:
      return {
        ...state,
        PrefixValid: invalid,
        TitleValid: invalid,
        NameValid: invalid,
        PurposeValid: invalid,
        TreeDigitCodeValid: invalid,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/StepsValidationReducer/Step2ValidationResult.js